// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bx--dropdown[data-v-25e86614]{border-bottom:none}.cv-header.bx--header[data-v-25e86614]{z-index:1;background-color:#fff;height:53px;border:none}.cv-header-name.bx--header__name[data-v-25e86614]{font-weight:400;font-size:14px;padding:0}", ""]);
// Exports
module.exports = exports;
